import React from 'react';
import { VersionResponse } from '../types';

interface VersionCardProps {
  version: VersionResponse;
  onViewDetails: (version: VersionResponse) => void;
  onEdit: (version: VersionResponse) => void;
  onDeprecate: (version: VersionResponse) => void;
}

const VersionCard: React.FC<VersionCardProps> = ({ version, onViewDetails, onEdit, onDeprecate }) => {
  const releasedDate = version.released_at
    ? new Date(version.released_at).toLocaleDateString()
    : 'Unreleased';

  return (
    <div className="glass-card" style={{ padding: '20px', marginBottom: '12px' }}>
      {/* Header row */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <span style={{ fontWeight: 700, fontSize: '16px' }}>{version.version}</span>
          {version.codename && (
            <span style={{ opacity: 0.6, fontStyle: 'italic' }}>"{version.codename}"</span>
          )}
        </div>
        <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
          {version.is_latest && <span className="status-badge status-active">latest</span>}
          {version.is_stable && <span className="status-badge status-active">stable</span>}
          {version.is_lts && <span className="status-badge status-provisioning">LTS</span>}
          {version.is_security_patch && <span className="status-badge status-provisioning">security</span>}
          {version.is_deprecated && <span className="status-badge status-suspended">deprecated</span>}
        </div>
      </div>

      {/* Details */}
      <div style={{ fontSize: '13px', opacity: 0.7, marginBottom: '12px', display: 'flex', flexDirection: 'column', gap: '4px' }}>
        <div>Released: {releasedDate}</div>
        {version.minimum_upgrade_from && (
          <div>Minimum upgrade from: {version.minimum_upgrade_from}</div>
        )}
        <div>Images: {version.api_image.split('/').pop()}, {version.ui_image.split('/').pop()}</div>
      </div>

      {/* Feature summary */}
      {version.new_features && version.new_features.length > 0 && (
        <div style={{ fontSize: '13px', marginBottom: '12px' }}>
          <span style={{ opacity: 0.5 }}>Features:</span>{' '}
          {version.new_features.slice(0, 2).join(', ')}
          {version.new_features.length > 2 && ` +${version.new_features.length - 2} more`}
        </div>
      )}

      {version.breaking_changes && version.breaking_changes.length > 0 && (
        <div style={{ fontSize: '13px', color: 'var(--warning)', marginBottom: '12px' }}>
          {version.breaking_changes.length} breaking change{version.breaking_changes.length > 1 ? 's' : ''}
        </div>
      )}

      {/* Actions */}
      <div style={{ display: 'flex', gap: '8px', borderTop: '1px solid rgba(255,255,255,0.1)', paddingTop: '12px' }}>
        <button className="btn btn-sm btn-secondary" onClick={() => onViewDetails(version)}>
          View Details
        </button>
        <button className="btn btn-sm btn-secondary" onClick={() => onEdit(version)}>
          Edit
        </button>
        {!version.is_deprecated && (
          <button className="btn btn-sm btn-secondary" onClick={() => onDeprecate(version)}>
            Deprecate
          </button>
        )}
      </div>
    </div>
  );
};

export default VersionCard;
